import angular from 'angular';
import { timeZonePickerComponent } from './timeZonePickerComponent';

angular
	.module('sh.timeZonePicker', ['sh.timeZone', 'sh.typeaheadSelect'])
	.component('shTimeZonePicker', timeZonePickerComponent());
